export default {
  DARK: {
    heading: p => p.primaryLight,
    paragraph: p => p.accentWhite,
    background: p => p.tertiaryDark,
    pDark: p => p.primaryDark,
    pLight: p => p.primaryLight,
    iconColor: p => p.primaryLight
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryNormal,
    background: p => p.tertiaryLight,
    pDark: p => p.primaryDark,
    pLight: p => p.primaryLight,
    iconColor: p => p.primaryDark
  },
  EXTRALIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryNormal,
    background: p => p.tertiaryExtraLight,
    pDark: p => p.primaryDark,
    pLight: p => p.primaryLight,
    iconColor: p => p.primaryDark
  }
}
